import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {AppService, AuthUser} from '../../utils/services/app.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

  public authUser: AuthUser;
  constructor(private appService: AppService) {
  }

  ngOnInit() {
    this.authUser = this.appService.getAuthUser();
  }

  signOut() {
    this.appService.logoutUser();
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/header/header.component.ts